import { render, staticRenderFns } from "./ChangeAppointmentPropsDialog.vue?vue&type=template&id=1c18a43c&scoped=true&"
import script from "./ChangeAppointmentPropsDialog.vue?vue&type=script&lang=ts&"
export * from "./ChangeAppointmentPropsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c18a43c",
  null
  
)

export default component.exports